var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"separation"},[_c('div',{staticClass:"mb-8 border-t-4 border-Black88 pb-2 pt-4 text-4xl"},[_c('div',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.item.separation_text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }